import a16 from "../../assets/samsung/a16/a16.jpeg";
import a16_blue_black from "../../assets/samsung/a16/a16_blue_black.jpeg";
import a16_gold from "../../assets/samsung/a16/a16_gold.jpeg";
import a16_light_green from "../../assets/samsung/a16/a16_light_green.jpeg";

import a56 from "../../assets/samsung/a56/a56.jpeg";
import a56_graphite from "../../assets/samsung/a56/a56_graphite.jpeg";
import a56_light_grey from "../../assets/samsung/a56/a56_light_grey.jpeg";

import a36 from "../../assets/samsung/a36/a36.jpeg";
import a36_black from "../../assets/samsung/a36/a36_black.jpeg";
import a36_lavender from "../../assets/samsung/a36/a36_lavender.jpeg";
import a36_white from "../../assets/samsung/a36/a36_white.jpeg";

import a26 from "../../assets/samsung/a26/a26.jpeg";
import a26_white from "../../assets/samsung/a26/a26_white.jpeg";
import a26_peach from "../../assets/samsung/a26/a26_peach.jpeg";
import a26_mint from "../../assets/samsung/a26/a26_mint.jpeg";
import a26_black from "../../assets/samsung/a26/a26_black.jpeg";

import a06 from "../../assets/samsung/a06/a06.jpeg";
import a06_light_green from "../../assets/samsung/a06/a06_light_green.jpeg";
import a06_light_grey from "../../assets/samsung/a06/a06_light_grey.jpeg";
import a06_black from "../../assets/samsung/a06/a06_black.jpeg";

export const galaxyASeries = [
  {
    id: 1,
    title: "Galaxy A16",
    productImage: a16,
    images: [a16, a16_blue_black, a16_gold, a16_light_green],
    // originalPrice: '₹ 13,999',
    discountedPrice: "13,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Blue", "Black", "Light", "Green", "Gold"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.5" inch - 720 X 1600(HD+)',
        "Max. Refresh Rate = 90 Hz",
        "Powered by MediaTek Dimensity 6300",
        "Up to 8GB RAM & Up to 256GB Storage (External Storage support - MicroSD up to 1.5TB)",
        "Triple Rear camera - 50 MP(Main Camera)+ 5 MP(Ultra-wide) + 2 MP(Depth Camera)",
        "Front Camera - 13MP (Selfie sensor)",
        "5000mah",
        "IP67 Water Resistance.",
      ],
    },
  },
  {
    id: 2,
    title: "Galaxy A56",
    productImage: a56,
    images: [a56, a56_graphite, a56_light_grey],
    // originalPrice: '₹ 13,999',
    discountedPrice: "37,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Awesome Olive", "Awesome Lightgray", "Awesome Graphite"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.7"inch Super AMOLED Infinity-O, Full HD+ (2340 x 1080)',
        "Max. Refresh Rate = 120 Hz",
        "Powered by Exynos 1580(4nm). Xclipse540 GPU",
        "Up to 12GB RAM & Up to 256GB Storage.",
        "Triple Rear camera - 50 MP(Main Camera - f/1.8 with OIS & PDAF)+ 12 MP(Ultra-wide) + 5 MP (Macro sensor)",
        "Front Camera - 12MP (f/2.2) sensor with 10-bit HDR and 4K video support",
        "5000mah",
        "IP67 Water Resistance",
      ],
    },
  },
  {
    id: 3,
    title: "Galaxy A36",
    productImage: a36,
    images: [a36, a36_black, a36_lavender, a36_white],
    // originalPrice: '₹ 13,999',
    discountedPrice: "26,499",
    // offerText: 'Flat ₹3,901 off',
    colors: [
      "Awesome Black",
      "Awesome Lavender",
      "Awesome White and Awesome Lime",
    ],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.7"inch Super AMOLED Infinity-O, Full HD+ (1080 x 2340)',
        "Max. Refresh Rate = 120 Hz",
        "Powered by Qualcomm Snapdragon 6 Gen 1",
        "Up to 12GB RAM & Up to 256GB Storage.",
        "Triple Rear camera - 50 MP(Main Camera with OIS)+ 8 MP(Ultra-wide) + 5 MP(Macro sensor)",
        "Front Camera - 12MP selfie cam with 10-bit HDR and 4K video support",
        "5000mah",
        "IP67 Water Resistance",
      ],
    },
  },
  {
    id: 4,
    title: "Galaxy A26",
    productImage: a26,
    images: [a26, a26_white, a26_peach, a26_mint, a26_black],
    // originalPrice: '₹ 13,999',
    discountedPrice: "24,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Awesome Black", "Awesome Mint", "Awesome Peach", "Awesome White"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.7"inch Super AMOLED, Full HD+ (1080 x 2340)',
        "Max. Refresh Rate = 120 Hz",
        "Powered by Samsung Exynos 1380",
        "Up to 8GB RAM & Up to 256GB Storage (External Storage support - MicroSD up to 2TB)",
        "Triple Rear camera - 50 MP(Main Camera with OIS)+ 8 MP(Ultra-wide) + 2 MP (Macro sensor)",
        "Front Camera - 13MP",
        "5000mah",
        "IP67 Water Resistance",
      ],
    },
  },
  {
    id: 5,
    title: "Galaxy A06",
    productImage: a06,
    images: [a06, a06_light_green, a06_light_grey, a06_black],
    // originalPrice: '₹ 13,999',
    discountedPrice: "10,499",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Light green", "Light grey", "Black"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.7"inch - 720 X 1600(HD+)',
        "Max. Refresh Rate = 90 Hz",
        "Powered by MediaTek Dimensity 6300",
        "Up to 6GB RAM & Up to 128GB Storage (External Storage support -MicroSD up to 1.5TB)",
        "Dual Rear camera 50 MP (Main Camera) + 2 MP (Depth Camera)",
        "Front Camera 12MP",
        "5000mah",
        "IP54 Water Resistance.",
      ],
    },
  },
];
